import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = ['Material listo para aplicar desde el día 1', 'Ejemplos 100% del contexto del taller argentino', 'Tablas de referencia rápida', 'Proyectos paso a paso para situaciones reales', 'Sin tecnicismos aburridos ni teoría vacía', 'Optimizado para celular y tablet', 'Planos y medidas en sistema métrico argentino', 'Ejercicios prácticos de autoevaluación', 'Contexto real de mercado y taller argentino', 'Actualizado con las técnicas que se usan hoy'];
  return <section className="py-12 bg-black border-y border-amber-900/40" data-id="element-145">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-146">
        <h3 className="text-2xl font-bold text-center mb-10 text-white" data-id="element-147">
          ✅ Todos los módulos incluyen:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-148">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg hover:bg-zinc-900/50 transition-colors" data-id="element-149">
              <CheckCircle2 className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" data-id="element-150" />
              <span className="text-zinc-100 font-medium text-[16px]" data-id="element-151">
                {item}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}